import BaseListPresenter from "../../../../../../base/BaseListPresenter";
import { findObjectUseCase } from "../../../../../../usecases/object";

class NoticesPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    const employee = this.view.props.employee;
    this.limit = 10;
    this.where = { "employees.id": employee.id };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.progress = true;
    this.reset();
  }

  // createQuery() {
  //   const skip = (this.current - 1) * this.limit;
  //   const query = {
  //     limit: this.limit,
  //     skip: skip,
  //     where: { ...this.where, ...this.search, ...this.filter },
  //     include: this.include,
  //   };
  //   if (this.sort) {
  //     query.sort = this.sort;
  //   }
  //   const keys = this.keys || this.view.getKeys() || [];
  //   if (keys.length > 0) {
  //     query.keys = keys;
  //   }
  //   return query;
  // }

  async objectQuery() {
    const fields = [
      "region",
      "office",
      "division",
      "section",
      "unit",
      "cluster",
    ];

    const fieldNameMap = {
      cluster: "plantilla",
      region: "regions",
      office: "offices",
      division: "divisions",
      section: "sections",
      unit: "units",
    };

    const employeeID = this.view.props.employee;
    const employee = await findObjectUseCase().execute("employees", {
      where: {
        id: employeeID.id,
      },
      keys: fields,
    });
    const lastNonEmptyField = fields
      ?.slice()
      .reverse()
      .find((field) => employee[0][field]);

    const mappedField = lastNonEmptyField
      ? fieldNameMap[lastNonEmptyField] || lastNonEmptyField
      : null;

    const lastNonEmptyValue = lastNonEmptyField
      ? employee[0][lastNonEmptyField]
      : null;

    const skip = (this.current - 1) * this.limit;
    return {
      where: {
        $or: [
          { "employees.id": { $exists: true, $eq: employeeID.id } },
          {
            [mappedField]: lastNonEmptyValue,
            "employees.id": { $exists: false },
          },
          { sendToAll: true },
        ],
        ...this.filter,
        ...this.search,
      },
      sort: { createdAt: -1 },
      skip: skip,
      limit: this.limit,
      include: this.include,
    };
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = await this.objectQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async setCount() {
    try {
      const count = await findObjectUseCase().execute(
        this.view.getCollectionName(),
        {
          where: (await this.objectQuery()).where,
        }
      );
      return count.length;
    } catch (e) {
      console.error(e);
    }
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }
}
export default NoticesPresenter;
